module.exports = __webpack_public_path__ + "media/images/icon_entry-3b9d192ab8471b8f9fb7152d6dcec901.svg";